<template>
  <div class="term-details">
    <h1 class="term-details__title">{{ title }}</h1>

    <a-lazy-hydrate v-if="!hideDescription" when-visible>
      <a-render-html
        :html="termDetails"
        class="term-details__description article-body-normal text-body"
      />
    </a-lazy-hydrate>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { processHtml } from '@/utils/helpers/processHtml'
import ARenderHtml from 'shared/ARenderHtml'

export default {
  name: 'ATermDetails',
  components: { ARenderHtml },
  props: {
    title: propValidator([PROP_TYPES.STRING]),
    description: propValidator([PROP_TYPES.STRING]),
    hideDescription: propValidator([PROP_TYPES.BOOLEAN], false, false),
    termId: propValidator([PROP_TYPES.STRING]),
    termName: propValidator([PROP_TYPES.STRING])
  },
  data() {
    return {
      isTermExpanded: false
    }
  },
  computed: {
    termDetails() {
      return processHtml(this.description)
    },
    termPath() {
      return this.$route.fullPath
    },
    termTextDescription() {
      return this.$helper.htmlToText(this.description)
    },
    emailTitle() {
      return `You’re going to love it: ${this.termName}`
    },
    emailDescription() {
      return `Check out this Term definition from investingLive: ${this.$env.IL_DOMAIN_URL}${this.termPath}`
    },
    termOfTheDayDescription() {
      return this.isTermExpanded
        ? this.termDetails
        : this.$helper.htmlToText(this.termDetails)
    }
  },
  methods: {
    onExpand() {
      this.isTermExpanded = true
    },
    onCollapse() {
      this.isTermExpanded = false
      this.$helper.scrollToTop(this)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/styles/_article-body.scss';

.term-details {
  width: 100%;
  position: relative;
  margin-top: 4px;

  &__top-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @include desktop-md {
      align-items: baseline;
    }

    @include mobile {
      flex-direction: column;
    }
  }

  &__title {
    margin: 4px 0 32px 0;
    font-weight: 500;

    @include mobile {
      margin-bottom: 10px;
    }
  }

  &__description {
    overflow: hidden;
    height: auto;

    /deep/ a {
      color: $c--main;

      &:hover {
        text-decoration: underline;
      }
    }

    /deep/ figure {
      max-width: 100%;
      margin: 20px 0 20px;

      @include mobile {
        max-width: calc(100vw - 30px);
      }
    }
  }

  &__suggest-a-term {
    max-width: 190px;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;

    @include mobile {
      position: relative;
      max-width: 100%;
      margin-top: 20px;
    }
  }
}
</style>
